import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-270a6314"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import AppIdenticon from '@/popup/components/shared/AppIdenticon/AppIdenticon.vue'
import NetworkSwitchWrapper from '@/popup/components/shared/NetworkSwitchWrapper.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardFrame',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(AppIdenticon),
    _createVNode(_component_router_view),
    _createVNode(NetworkSwitchWrapper)
  ]))
}
}

})